export default "https://housescan.app.solease.nl/static/media/cavity_insulation.bce7fd6f.svg";